import { t } from "@web-monorepo/i18n/macro";
import { DDSTextarea } from "@web-monorepo/dds";
import { ToolPayload } from "src/pods/toolkitData/components/EditableSetup";

type PairShareEditProps = {
  onEdit: (payload: ToolPayload, disabled?: boolean) => void;
  payload: ToolPayload;
};

export default function PairShareEdit({ onEdit, payload }: PairShareEditProps) {
  return (
    <DDSTextarea
      data-name="pair_share_edit:textarea"
      label={t`Write out a question or topic you'd like students to discuss with their neighbor`}
      rows={3}
      onChange={(text) => onEdit({ text }, !text)}
      value={payload ? payload.text : ""}
    />
  );
}
